import { Component, OnInit } from '@angular/core';
import { SessionService } from '@app/core/services';
import { SocoHttpService } from '@app/soco/http';
import { LandingService } from '../services';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit {
public builderCompanies: any[] = [];
public companies: string[] = [];
  constructor(public landingSvc: LandingService, public sessionSvc: SessionService, public socoHttp: SocoHttpService) {

   }

  ngOnInit() {



  }

}
